<template>
    <div class="main-wrapper d-flex justify-center" v-if="initalDataLoaded">
        <transition :name="animationFade" >
            <div v-if="show">
                <v-row class="section_wrapper d-flex justify-space-between">
                    <v-col cols=12 md=4 class="left-text" v-if="brokerData">
                        <h2 class="left-title">{{brokerData.portal_data.title}}</h2>
                        <h6 class="left-title">{{brokerData.portal_data.subtitle}}</h6>
                        <div class="left-p mt-8">
                            <p v-for="(bullet, index) in brokerData.portal_data.bullets" :key="index">
                                <v-icon color="var(--helloteca-main)" > mdi-check </v-icon> {{bullet}}
                            </p>
                        </div>
                    </v-col>
                    <v-col cols=12 md=7 class="form_wrapper pt-12 pt-md-0">
                        <h2 class="mb-2">{{productTitle}}</h2>
                        <ChangeProductBlock />
                        <h2 class="mt-6 mb-3">Datos de contacto</h2>
                        <v-form ref="form" lazy-validation v-model="valid">
                            <div>
                                <v-row>
                                    <v-col cols="12" class="pb-0">
                                        <v-text-field
                                            label="Nombre completo *"
                                            v-model="preScoring.Titulares.primer_titular.nombre_completo"
                                            :rules="[...ruleRequired]"
                                            outlined
                                            validate-on-blur
                                            dense
                                            color="var(--helloteca-main)"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="pb-0">
                                        <v-autocomplete 
                                            attach
                                            no-data-text="Sin datos"
                                            label="Comunidad autónoma *"
                                            v-model="preScoring.Vivienda.ccaa"
                                            :items="commonVars.ccaa"
                                            :rules="[...ruleRequired]"
                                            item-text="name"
                                            item-value="code"
                                            outlined
                                            validate-on-blur
                                            dense
                                            color="var(--helloteca-main)"
                                        />
                                    </v-col>
                                    <v-col cols="12" md=6 class="pb-0">
                                        <v-text-field
                                            label="Email *"
                                            v-model="preScoring.Titulares.primer_titular.email"
                                            :rules="[...ruleRequired, ...ruleEmail]"
                                            outlined
                                            color="var(--helloteca-main)"
                                            validate-on-blur
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md=6 class="pb-0">
                                        <v-text-field
                                            label="Teléfono *"
                                            v-model="preScoring.Titulares.primer_titular.telefono"
                                            :rules="[...ruleRequired, ...rulePhone]"
                                            outlined
                                            color="var(--helloteca-main)"
                                            validate-on-blur
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" class="d-flex align-center">
                                        <v-checkbox  v-if="brokerData" class="mt-0" :rules="[v => !!v || 'Por favor, acepta los términos de uso y la política de privacidad']" v-model="temsActive" color="var(--helloteca-main)">
                                                <template v-slot:label>
                                                    <div class="legal_text">He leído y acepto los <a href="https://helloteca.com/terminos-y-condiciones" target="_blank" @click.stop>Términos de uso</a> y la <a href="https://helloteca.com/politica-privacidad" target="_blank" @click.stop>Política de privacidad</a></div>
                                                </template>
                                        </v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" class="d-flex flex-column align-end">
                                        <v-btn @click="send" :loading="loading" depressed class="blue_button">Siguiente</v-btn>
                                        <p class="steps_info">Paso 1 de 3</p>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-form>
                    </v-col>
                </v-row>
            </div>
        </transition>
        <v-dialog v-model="ducplicatedDialog" persistent max-width="550" >
            <v-card>
                <v-card-title class="head_dialog d-flex justify-center">
                    <p class="hrtitle">Usuario ya activo en Helloteca</p>
                    <v-btn style="position: absolute; right: 5px; top: 5px;" icon @click="ducplicatedDialog=false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="d-flex flex-column align-center justify-center">
                    <p style="text-align: center;">El usuario que se intenta dar de alta con el email: <br><strong>{{preScoring.Titulares.primer_titular.email }}</strong> <br><br><span style="color:red">Ya ha sido activado en Helloteca</span></p>
                </v-card-text>
                <v-card-actions class="modal_actions d-flex justify-center align-center">
                    <button class="confirm_button" @click="ducplicatedDialog=false">Cerrar</button>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import rulesMixin from '../mixins/rulesMixin';
    import axios from 'axios';
    import ChangeProductBlock from '../components/ChangeProductBlock';
    import goTo from 'vuetify/es5/services/goto'

    const newApi = 'https://api.helloteca.com';

    export default {
        mixins: [rulesMixin],
        components:{
            ChangeProductBlock
        },
        data() {
            return {
                valid: false,
                initalLoading: false,
                data: {},
                show:false,
                animationFade: 'fadeR',
                ducplicatedDialog: false
            }
        },
        mounted() {
            this.animationFade = (this.activeStep > 1) ? 'fadeL' : 'fadeR'
            this.show = true;
            this.SET_ACTIVE_STEP(1);
            this.SET_LOADING(false);
            if(!this.$route.params.office){this.$route.params.office='default'} 
            if(this.$route.params.broker=='solvia'){
                this.$router.push({name: 'Solvia',params: { broker: this.brokerData.portal_data.code,office:this.$route.params.office } }); 
            }
            
        },
        methods: {
            ...mapMutations([
                'SET_ACTIVE_STEP',
                'SET_TERMS',
                'SET_LOADING',
                'SET_TOKEN_ID',
                'SET_PRESCORING_DATA',
                'SET_STEP_WITH_ERROR'
            ]),
            send(){
                let id_office='';
                if(this.$route.params.office && this.$route.params.office !='default'){
                    id_office = this.brokerData.offices.filter(item => item == this.$route.params.office)[0]||'';
                }

                let utm_params = {
                    origen: this.brokerData.portal_data.code,
                    source: this.brokerData.portal_data.code,
                    subsource: id_office
                };
                if(this.$route.query.utm_campaign)
                    utm_params = {...utm_params, utm_campaign: this.$route.query.utm_campaign}

                if(this.$route.query.utm_content)
                    utm_params = {...utm_params, utm_content: this.$route.query.utm_content}

                if(this.$route.query.utm_medium)
                    utm_params = {...utm_params, utm_medium: this.$route.query.utm_medium}

                if(this.$route.query.utm_source)
                    utm_params = {...utm_params, utm_source: this.$route.query.utm_source}

                if(this.$route.query.utm_term)
                    utm_params = {...utm_params, utm_term: this.$route.query.utm_term}

                let source_params = null;
                if(this.$route.query.source)
                    source_params = {...source_params, origen: this.$route.query.source}
                else 
                    source_params = {...source_params, origen: utm_params.source}

                if(this.$route.query.subsource)
                    source_params = {...source_params, subsource: this.$route.query.subsource}
                
                if(this.$route.query.agent)
                    source_params = {...source_params, agent: this.$route.query.agent}

                let postData = {
                    nombre_completo: this.preScoring.Titulares.primer_titular.nombre_completo,
                    email: this.preScoring.Titulares.primer_titular.email,
                    telefono: this.preScoring.Titulares.primer_titular.telefono,
                    ccaa: this.preScoring.Vivienda.ccaa,
                    tipo_prestamo: this.preScoring.Vivienda.tipo_prestamo,
                    lead_type: "L1",
                    ...utm_params,
                    ...source_params
                };

                if (postData.tipo_prestamo) {
                    postData.tipo_vivienda = "liquidez";
                } else {
                    postData.tipo_vivienda = this.preScoring.Vivienda.tipo_vivienda;
                }

                if(this.$refs.form.validate()){
                    this.SET_LOADING(true);
                    axios
                        .post(
                            `${newApi}/public/prescoringV2/init/broker`,
                            postData,
                            {headers: this.callsHeader}
                        )
                        .then(
                            response => {
                                this.SET_LOADING(false);
                                if(response.status){
                                    if(response.data.data.url){
                                        console.log(response.data.data.url);
                                        window.location.href=response.data.data.url;
                                    }else{
                                        // Save token id in state data
                                        this.SET_TOKEN_ID(response.data.data.PreScoring.token_id);
                                        // Save cookie in client browsers
                                        this.$cookies.set('ds_noauth_token', response.data.data.PreScoring.token_id);
                                        this.SET_PRESCORING_DATA(response.data.data.PreScoring);
                                        this.SET_ACTIVE_STEP(2);
                                        this.$router.push({name: 'View2',params: { broker: this.$route.params.broker,office:this.$route.params.office} })
                                    }
                                }else{
                                    // reject(response)
                                    console.log('Error: ' , response);
                                }
                            }
                        ).catch(error=> {
                            this.SET_LOADING(false);
                            console.log('Error: ' , error);
                            if(error.response.status == 409){
                                this.ducplicatedDialog = true;
                            }
                        });

                    
                }else{
                    setTimeout(() => {
                        const el = document.querySelector(".v-messages.error--text:first-of-type");
                        goTo(el, {offset:120});
                    }, 200);
                }
            }
        },
        computed: {
            ...mapState([
                'activeStep',
                'commonVars',
                'initalDataLoaded',
                'preScoring',
                'products',
                'token_id',
                'loading',
                'terms',
                'brokerData',
                'callsHeader'
            ]),
            temsActive: {
                get() {
                    return this.terms;
                },
                set(value) {
                    this.SET_TERMS(value);
                }
            },
            productTitle(){
                if (this.brokerData && this.brokerData.portal_data && this.brokerData.portal_data.productos) {
                    if (this.preScoring.Vivienda.tipo_vivienda) {
                        const product = this.brokerData.portal_data.productos.hipotecas.find(product => product.type === this.preScoring.Vivienda.tipo_vivienda);
                        return product ? product.title : '';
                    } 
                    if (this.preScoring.Vivienda.tipo_prestamo) {
                        const product = this.brokerData.portal_data.productos.prestamos.find(product => product.type === this.preScoring.Vivienda.tipo_prestamo);
                        return product ? product.title : '';
                    }
                } else {
                    const product = this.products.find(product => product.type === this.preScoring.Vivienda.tipo_vivienda);
                    return product ? product.title : '';
                }
                return '';
            }
        },
        watch: { 
      	    loading: function() { // watch it
                if(!this.initalLoading){
                    this.initalLoading = true;
                }
            },
            valid: function(val){
                this.SET_STEP_WITH_ERROR(!val)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-wrapper{
        padding: 20px;
        box-sizing: border-box;
    }
    .section_wrapper{
        max-width: 1150px;
        .left-text{
            h2{
                font-weight: 800;
                font-size: 1.6rem;
                line-height: 1.9rem;
                color: var(--helloteca-main);
            }
            p{
                font-weight: 500;
                font-size: 0.9rem;
                line-height: 1.6rem;
                span{
                    color: var(--helloteca-main);
                    font-weight: bold;
                }
            }
        }
    }
    .form_wrapper{
        h2{
            font-weight: bold;
            color: var(--helloteca-main);
            font-size: 1.2rem;
            line-height: 1.3rem;
        }
    }
    .custom-control-description {
		float: left;
		color: #90A4AE;
		padding-left: 1rem;
		padding-top: 5px;
        a {
            color: var(--helloteca-main);
        }
    }
    .legal_text{
        font-size: .9rem;
        a{
            color: var(--helloteca-main);
        }
    }
    .steps_info{
        font-size: 0.8rem;
        line-height: .9rem;
        color: #999;
        margin-top: 10px;
    }
    .left-title{
        font-size: 2.1rem !important;
        line-height: 2.5rem !important;
        @media (max-width: 960px) {
            font-size: 1.7rem !important;
            text-align: center;
        }
    }
    .left-p{
        @media (max-width: 960px) {
            margin-top: 15px !important;
            text-align: center;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 15px;
            p{
                font-size: .8rem !important;
                margin-bottom: 0 !important;
                width: 100%;
                text-align: center;
                padding: 0 10px;
            }
        }
        p{
            font-size: 1rem !important;
            @media (max-width: 960px) {
                font-size: 1.1rem !important;
                margin-bottom: 10px !important;
            }
            span{
                margin-top: 6px;
                font-size: 1.6rem;
                @media (max-width: 960px) {
                    font-size: 1.1rem !important;
                    margin-bottom: 0 !important;
                }
            }
        }
    }
</style>